package com.royceecoleman.bill.pages

internal const val AI_CHAT_DASHBOARD_DESCRIPTION = "Open the AI chat workspace."
internal const val AI_CHAT_CONVERSATION_SUPPORTING_TEXT = "Continue the conversation below."

internal fun aiChatHeaderSupportingText(username: String): String = "Signed in as $username. Start a conversation or pick a previous chat."
